import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import CandidateProfile from './CandidateProfile';

const CandidatePortal: React.FC = () => {
  const { nameSlug } = useParams<{ nameSlug: string }>();

  // Validate that nameSlug exists and has valid format
  if (!nameSlug || nameSlug.length < 2) {
    return <Navigate to="/login" />;
  }

  return <CandidateProfile />;
};

export default CandidatePortal;